import { Box, Button, Modal, Stack, TextField } from '@mui/material';
import { Favorite } from '../types';

/** Aceita apenas números positivos, inclusive decimais incompletos como "1.". */
const DECIMAL_INPUT = /^\d*\.?\d*$/;

const numberInputProps = {
  min: 0, // bloqueia negativos no spinner e na validação
  step: 'any', // permite qualquer precisão decimal
  pattern: '[0-9]*\\.?[0-9]*',
};

type EditPositionModalProps = {
  editing: Favorite | null;
  onChange: (next: Favorite) => void;
  onCancel: () => void;
  onSave: (favorite: Favorite) => void;
};

/** Modal da aba Carteira para editar quantidade e meta de um ativo. */
export function EditPositionModal({ editing, onChange, onCancel, onSave }: EditPositionModalProps) {
  const handleNumber = (value: string, apply: (n: number) => Favorite) => {
    if (value === '' || DECIMAL_INPUT.test(value)) {
      onChange(apply(value === '' ? 0 : Number(value)));
    }
  };

  return (
    <Modal
      open={!!editing}
      onClose={onCancel}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}>
        <h2 id="parent-modal-title">{editing?.ticker}</h2>

        <TextField
          label="Quantidade"
          variant="outlined"
          type="number"
          inputMode="decimal"
          value={editing?.quantity ?? ''}
          onChange={(e) => handleNumber(e.target.value, (quantity) => ({
            ...editing,
            ticker: editing?.ticker ?? '',
            quantity,
          }))}
          inputProps={numberInputProps}
        />

        <TextField
          label="Meta"
          variant="outlined"
          type="number"
          inputMode="decimal"
          value={editing?.goal ?? ''}
          onChange={(e) => handleNumber(e.target.value, (goal) => ({
            ...editing,
            ticker: editing?.ticker ?? '',
            quantity: editing?.quantity ?? 0,
            goal,
          }))}
          inputProps={numberInputProps}
        />

        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={() => {
              if (editing) onSave(editing);
            }}
          >
            Save
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
